// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){ 

	$(document).ready(function () {
		$('body.sitemap').attr('id','default');

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});
		
		$(".language-btn").change(function(e){
			e.preventDefault()
			
			let langSel 	=$(this).val().toLowerCase();
			let pathname 	= document.location.pathname
			let origin 		= document.location.origin
			let langs 		= ['es','fr','de','pt','it']
			for (const key in langs) {
				if(pathname.indexOf(`/${langs[key]}/`)>-1)
					pathname = pathname.replace(`/${langs[key]}/`,'')
			}

			if(langSel!='en'){
				if($('body').attr('id')==='home')
					document.location = origin+'/'+langSel
				else{
					let newUrl =langSel+'/'+pathname
					newUrl = newUrl.replace('//','/')
					document.location = origin+'/'+newUrl
				}
			}else{
				if($('body').attr('id')==='home')
					document.location = origin+'/'
				else
					document.location = origin+'/'+pathname
			}

		});

		// RESTAURANT MENUS FILTER
		document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.restMenus_item').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
						room.classList.add('active');
					}
				});
			});

			if (i === 0) btn.click();
		});
		
	});  

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW(); 

			let animatedEl = document.getElementsByClassName('animate');
			const h = window.innerHeight;
			var i;
			for (i = 0; i < animatedEl.length; i++) {
				var viewportOffset = animatedEl[i].getBoundingClientRect();
				let topPos = viewportOffset.top;
				//animatedEl[i].innerHTML = topPos;
				if(topPos <= h*0.8){
					animatedEl[i].classList.add('fade-in');
				}
			}
		})
	};


	
	let bookingText = document.querySelector('.booking-text');
	let bookingWidgetContainer = document.querySelector('.booking-widget-container');

	if (bookingText !== null) {
		bookingWidgetContainer.appendChild(bookingText);
	} else {
		console.log(".booking-text element doesn't exist.");
	}

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
			// if(!document.getElementById('booking-widget-container').classList.contains('down')){
			// 	document.getElementById('booking-widget-container').classList.add('down');
			// 	document.getElementById('booking-widget-container').classList.remove('up');
			// }
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
			// if(!document.getElementById('booking-widget-container').classList.contains('up')){
			// 	document.getElementById('booking-widget-container').classList.add('up');
			// 	document.getElementById('booking-widget-container').classList.remove('down');
			// }
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		// if(document.getElementById('booking-widget-container').classList.contains('up') || document.getElementById('booking-widget-container').classList.contains('down')){
		// 	document.getElementById('booking-widget-container').remove('up');
		// 	document.getElementById('booking-widget-container').classList.remove('down');
		// }
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}